import { Injectable } from '@angular/core';

import { BetslipPick } from '../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../../../core/picks/betslip-v2-option-market-pick';
import { ISlip } from '../../../../bet-generation/models';
import { ComboSlipType, SingleSlipType, SystemSlipType } from '../../../../bet-generation/slip-type';
import { MinimumComboPreCheckError } from '../../../errors/pre-check/minimum-combo-pre-check-error';

@Injectable()
export class MinimumCombinationValidator {
    getRestrictions(picks: BetslipPick[]): Record<string, number> {
        const result: Record<string, number> = {};
        for (const pick of picks) {
            if ((pick instanceof BetslipV1Pick || pick instanceof BetslipV2OptionMarketPick) && (pick.market.minimumCombo as number) > 1) {
                result[pick.id.toString()] = pick.market.minimumCombo as number;
            }
        }

        return result;
    }

    reduce(errors: MinimumComboPreCheckError[]): MinimumComboPreCheckError[] {
        const picks: Record<string, boolean> = {};

        return errors.filter((e) => {
            if (picks[e.pickId]) {
                return false;
            }
            picks[e.pickId] = true;

            return true;
        });
    }

    validateSlip(slip: ISlip, minimumComboRestrictions: Record<string, number>): MinimumComboPreCheckError[] {
        const slipPickIds = Object.keys(slip.slipPicks);
        if (slip.type instanceof SingleSlipType) {
            const slipPickId = slipPickIds[0];
            if (slipPickId in minimumComboRestrictions) {
                // has minimum combo restriction bigger than 1 === can not be used in a single slip
                return [new MinimumComboPreCheckError(slipPickId, minimumComboRestrictions[slipPickId] - 1, 1)];
            }
        } else if (slip.type instanceof ComboSlipType) {
            return slipPickIds
                .filter((pId) => pId in minimumComboRestrictions && slipPickIds.length < minimumComboRestrictions[pId])
                .map((pId) => new MinimumComboPreCheckError(pId, minimumComboRestrictions[pId] - slipPickIds.length, slipPickIds.length));
        } else if (slip.type instanceof SystemSlipType) {
            return slipPickIds
                .filter((pId) => pId in minimumComboRestrictions && slip.type.basis.some((basis) => basis < minimumComboRestrictions[pId]))
                .map((pId) => new MinimumComboPreCheckError(pId, minimumComboRestrictions[pId] - 1, Math.min.apply(null, slip.type.basis)));
        }

        return [];
    }
}
